import { useEffect, useState } from "react";
import { useSalon } from "../context/SalonContext";

const DISMISS_KEY = "kinng.trial.banner.dismissed";

/**
 * TrialBanner — banner sutil no topo do CRM enquanto o tenant está em trial.
 * - Some quando status !== "trial"
 * - Mostra dias restantes até trial_ends_at (âmbar quando <= 3 dias)
 * - Fechável apenas para a sessão atual (sessionStorage)
 */
export const TrialBanner = () => {
    const { brand, setActiveModule } = useSalon();
    const [dismissed, setDismissed] = useState(() => {
        try { return sessionStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
    });
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(t);
    }, []);

    const status = brand.status || brand.plan_status;
    const trialEndsAt = brand.trial_ends_at || brand.trialEndsAt;
    if (dismissed) return null;
    if (status !== "trial" || !trialEndsAt) return null;

    const end = new Date(trialEndsAt).getTime();
    const daysLeft = Math.max(0, Math.ceil((end - now) / 86400000));
    const critical = daysLeft <= 3;

    const dismiss = () => {
        try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
        setDismissed(true);
    };

    return (
        <div
            data-testid="trial-banner"
            className={`w-full border-b flex items-center justify-center gap-3 px-4 py-2 text-xs sm:text-sm transition-all ${
                critical
                    ? "bg-red-500/15 border-red-500/40 text-red-100"
                    : "bg-amber-500/10 border-amber-500/30 text-amber-100"
            }`}
        >
            <i className={`fa-solid ${critical ? "fa-triangle-exclamation" : "fa-clock"}`}></i>
            <span className="truncate">
                {daysLeft === 0 ? (
                    <>Seu trial <b>termina hoje</b>.</>
                ) : daysLeft === 1 ? (
                    <>Seu trial <b>termina amanhã</b>.</>
                ) : (
                    <>Seu trial termina em <b>{daysLeft} dias</b>.</>
                )}
            </span>
            <button
                data-testid="trial-banner-cta"
                onClick={() => setActiveModule("account")}
                className={`ml-2 rounded-lg font-bold px-3 py-1 text-[11px] uppercase tracking-[0.15em] transition-all ${
                    critical
                        ? "bg-red-500 hover:bg-red-400 text-white"
                        : "bg-amber-500 hover:bg-amber-400 text-slate-950"
                }`}
            >
                Assinar agora <i className="fa-solid fa-arrow-right ml-1"></i>
            </button>
            <button
                data-testid="trial-banner-dismiss"
                onClick={dismiss}
                title="Fechar por esta sessão"
                className="text-slate-400 hover:text-white transition-all ml-1"
            >
                <i className="fa-solid fa-xmark text-xs"></i>
            </button>
        </div>
    );
};

export default TrialBanner;
